import { render } from "./Index.vue?vue&type=template&id=7ffcd210"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=7ffcd210&lang=css"

import exportComponent from "/Users/aml/Projects/dashboardcopy2/fnbxv21-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__